// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qhEo","col":"styles_col__14L7D"};